module.exports = "<h2>Extension</h2><p>Add a method to ALL instances of a given class without building a wrapper class</p><pre class=\"fragment\"><code class=\"lang-kotlin\">fun String.sayHi() {\n    println(\"Hey there, ${this}!\")\n}</code></pre><pre class=\"fragment\"><code class=\"lang-kotlin\">fun main(args: Array&lt;String&gt;) {\n    // Prints \"Hey there, kiddos!\"\n    \"kiddos\".sayHi()\n}</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./src/slides/06-moar/04.pug
// module id = 334
// module chunks = 1